// Rest action card — wraps the shared renderActionCard helper so it
// renders identically to the in-game character-action cards. Click
// dispatches `rest-action-click` for game-map to handle.

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';
import { renderActionCard } from './action-card.js';
import { actionCardStyles } from './action-card-styles.js';

/**
 * @typedef {import('../../types/jsdoc-types.js').RestAction} RestAction
 */

class RestActionComponent extends BaseComponent {
  static properties = {
    action: { type: Object },
  };

  static styles = [
    actionCardStyles,
    css`
      :host {
        display: block;
        height: 100%;
      }
    `,
  ];

  constructor() {
    super();
    /** @type {RestAction|null} */
    this.action = null;
  }

  _handleClick() {
    if (!this.action || !this.action.enabled) return;
    this.dispatchEvent(
      new CustomEvent('rest-action-click', {
        detail: this.action,
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    if (!this.action) return html``;
    const { label, description, icon, enabled, disabledReason } = this.action;
    return renderActionCard({
      iconSlug: icon,
      title: label,
      summary: description,
      enabled,
      disabledReason,
      onClick: () => this._handleClick(),
    });
  }
}

customElements.define('rest-action', RestActionComponent);
